import type { TextWidgetV2 } from "@/elements/text/textV2";

export const getNewStartY = (
    textPart: TextWidgetV2,
    y: number,
    height: number,
    topPadding: number,
    bottomPadding: number | null,
    gap: number = 0,
): number => {
    const textVerticalAlign = textPart.getData().textVerticalAlign;
    if (textVerticalAlign === "top") {
        return y + textPart.lineHeight + topPadding;
    }
    if (textVerticalAlign === "bottom") {
        return (
            y +
            height +
            textPart.lineHeight -
            textPart.height -
            (bottomPadding !== null ? bottomPadding : topPadding)
        );
    }
    return y + gap + (height - gap) / 2 - textPart.height / 2 + textPart.lineHeight;
};

export const getNewStartYByHeight = (
    textPart: TextWidgetV2,
    y: number,
    heightBottom: number,
    heightCenter: number,
    topPadding: number,
    bottomPadding: number | null,
    gap: number = 0,
): number => {
    const textVerticalAlign = textPart.getData().textVerticalAlign;
    if (textVerticalAlign === "top") {
        return y + textPart.lineHeight + topPadding;
    }
    if (textVerticalAlign === "bottom") {
        return (
            y +
            heightBottom +
            textPart.lineHeight -
            textPart.height -
            (bottomPadding !== null ? bottomPadding : topPadding)
        );
    }
    return y + gap + (heightCenter - gap) / 2 - textPart.height / 2 + textPart.lineHeight;
};
